import { IDB_STORE_NAME } from '@actassa/shared';
import { DBConfig } from 'ngx-indexed-db';

import { migrationFactory } from '../helpers/migration-factory.helper';

export const IDB_DATA_COLLECTION_TEMPLATES_STORE = 'data-collection-templates';
export const IDB_DATA_COLLECTIONS_STORE = 'data-collections';
export const IDB_INDEX_PROVIDER_ID = 'providerID';
export const IDB_INDEX_TEMPLATE_ID = 'templateId';
export const IDB_INDEX_UUID = 'uuid';

export const idbConfig: DBConfig = {
    name: IDB_STORE_NAME,
    version: 2,
    objectStoresMeta: [
        {
            store: IDB_DATA_COLLECTIONS_STORE,
            storeConfig: { keyPath: 'id', autoIncrement: false },
            storeSchema: [
                { name: 'isDeleted', keypath: 'isDeleted', options: { unique: false } },
                { name: 'isFinished', keypath: 'isFinished', options: { unique: false } },
                { name: 'providerID', keypath: 'providerID', options: { unique: false } },
                { name: 'type', keypath: 'type', options: { unique: false } },
                { name: 'uuid', keypath: 'uuid', options: { unique: false } },
            ],
        },
        {
            store: IDB_DATA_COLLECTION_TEMPLATES_STORE,
            storeConfig: { keyPath: 'id', autoIncrement: false },
            storeSchema: [
                { name: 'providerID', keypath: 'providerID', options: { unique: false } },
                { name: 'type', keypath: 'type', options: { unique: false } },
            ],
        },
    ],
    migrationFactory,
};
